import { useParams } from 'react-router-dom'
import { getRequest } from '../../../services/base'
import DropDownMenu from '../../common/DropDownMenu'
import { downloadFileBlob } from '../../../utils/common'
import LinkWithStatus from '../../common/LinkWithStatus'
import { NavContext } from '../../../context/global_context'
import { useContext } from 'react'

const DownloadInlines = ({ isButton = true }) => {
  let { vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)

  const downloadInlineCsv = async (file_type) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Inline ${file_type} csv file.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/inline_connection/download/?vehicle=${vehicle}&file_type=${file_type}`,
      true,
      true
    )
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `${vehicle}_inline_${file_type}.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <DropDownMenu
      items={[
        {
          name: 'Export Suffix',
          value: 'suffix',
        },
        {
          name: 'Export Prefix',
          value: 'prefix',
        },
      ]}
      outsideClickClose={true}
      onClick={(item) => {
        downloadInlineCsv(item.value)
      }}
      showMenu={false}
    >
      {isButton ? (
        <LinkWithStatus
          href={`/administration/system/new`}
          className={
            'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
          }
          title="Export Prefix/Suffix"
          onClickFunc={() => {}}
        />
      ) : (
        <div className={`cursor-pointer inline-block text-blue-500 underline`}>
          Export Prefix/Suffix
        </div>
      )}
    </DropDownMenu>
  )
}

export default DownloadInlines
